import * as React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { Routes } from '@src/constants'
import { getCurrentAccount } from '@src/selectors'
import { Route } from '../shell/helpers'
import { useSelector } from 'react-redux'
import loadable from '@loadable/component'
import Loading from '@src/components/loading'

export interface Params {}
interface OwnProps {}
export type Props = OwnProps

const ObjectDetailsContainerLoadableComponent = loadable(
  () => import('./views/details'),
  {
    fallback: <Loading />
  }
)

const ObjectsSummaryContainerLoadableComponent = loadable(
  () => import('./views/summary'),
  {
    fallback: <Loading />
  }
)

const Objects: React.FC<Props> = React.memo((props: Props) => {
  const match = useRouteMatch<Params>()
  const currentAccount = useSelector(getCurrentAccount)
  return (
    <Switch>
      <Route
        exact
        path={`${Routes.patternPath}`}
        component={ObjectDetailsContainerLoadableComponent}
      />
      <Route
        withFilter
        path={`${match?.url}`}
        component={ObjectsSummaryContainerLoadableComponent}
        currentAccount={currentAccount}
      />
    </Switch>
  )
})

export default Objects
